export default function () {
  return [
    { id: 0, codigo: 'RS', name: 'RS' },
    { id: 1, codigo: 'SC', name: 'SC' },
    { id: 2, codigo: 'DF', name: 'DF' },
    { id: 3, codigo: 'MG', name: 'MG' },
    { id: 4, codigo: 'SP', name: 'SP' },
    { id: 5, codigo: 'RN', name: 'RN' },
    { id: 6, codigo: 'GO', name: 'GO' },
    { id: 7, codigo: 'AM', name: 'AM' },
    { id: 8, codigo: 'PA', name: 'PA' },
    { id: 9, codigo: 'PE', name: 'PE' },
    { id: 10, codigo: 'PB', name: 'PB' },
    { id: 11, codigo: 'ES', name: 'ES' },
    { id: 12, codigo: 'AP', name: 'AP' },
    { id: 13, codigo: 'TO', name: 'TO' },
    { id: 14, codigo: 'MT', name: 'MT' },
    { id: 15, codigo: 'PR', name: 'PR' },
    { id: 16, codigo: 'PI', name: 'PI' },
    { id: 17, codigo: 'RR', name: 'RR' },
    { id: 18, codigo: 'BA', name: 'BA' },
    { id: 19, codigo: 'CE', name: 'CE' },
    { id: 20, codigo: 'RJ', name: 'RJ' },
    { id: 21, codigo: 'AC', name: 'AC' },
    { id: 22, codigo: 'MA', name: 'MA' },
    { id: 23, codigo: 'AL', name: 'AL' },
    { id: 24, codigo: 'RO', name: 'RO' },
    { id: 25, codigo: 'MS', name: 'MS' },
    { id: 26, codigo: 'SE', name: 'SE' }]
}



// WEBPACK FOOTER //
// ./src/constants/siglasEstados.js